import { render, staticRenderFns } from "./websiteNavigation.vue?vue&type=template&id=5287938a&scoped=true&"
import script from "./websiteNavigation.vue?vue&type=script&lang=js&"
export * from "./websiteNavigation.vue?vue&type=script&lang=js&"
import style0 from "./websiteNavigation.vue?vue&type=style&index=0&id=5287938a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287938a",
  null
  
)

export default component.exports